export default [
  {
    path: '/stories/folders',
    name: 'stories-folders-index',
    role: ['admin', 'developer'],
    meta: {
      loadState: true,
      requiresAuth: true,
      isAuthView: false,
      parentGroup: 'stories',
    },
    component: () => import('@/views/stories/folders/Index'),
  },
  {
    path: '/stories/folders/create',
    name: 'stories-folder-create',
    role: ['admin', 'developer'],
    meta: {
      loadState: true,
      requiresAuth: true,
      isAuthView: false,
      parentGroup: 'stories',
      role: ['admin', 'developer'],
    },
    component: () => import('@/views/stories/folders/Create'),
  },
  {
    path: '/stories/folders/edit/:id',
    name: 'stories-folder-edit',
    role: ['admin', 'developer'],
    meta: {
      loadState: true,
      requiresAuth: true,
      isAuthView: false,
      parentGroup: 'stories',
    },
    component: () => import('@/views/stories/folders/Edit'),
    props: true,
  },
  {
    path: '/stories/folders/order',
    name: 'stories-folders-order',
    role: ['admin', 'developer'],
    meta: {
      loadState: true,
      requiresAuth: true,
      isAuthView: false,
      parentGroup: 'stories',
    },
    component: () => import('@/views/stories/folders/Order'),
  },
];
